export default {
    "lang": "英语",
    application: {
        name: 'Information Release System',
    },
    ajaxTip: {
        success: 'Success',
        error: 'Error',
        noAccess: 'Not authorized to access the resource',
        notFound: 'The resource not found',
        serverBusy: 'The server is busy, try later',
        timeOut: 'Time out',
    },
    menu: {
        home: 'Home',
        template: 'Template Manage',
        program: 'Program Manage',
        playplan: 'Play Plan',
        device: 'Device Manage',
        "source-material": 'Material Manage',
        material: 'Material',
        checkManage: 'Check Manage',
        setting: 'Setting',
        usercenter: 'User Center',
        adminManage: 'Device Manage',
        schedule: 'Schedule',
        capitalassets: 'Asset Manage',
        modifyPassword: 'Modify Password',
        logout: 'Log Out',
        add: "add",
        edit: "edit",
        delete: "delete",
        view: "view",
        "menu_1": "Home",
        "menu_2": "Device Manage",
        "menu_3": "Edit (Advanced Settings - Basic Edit - Change Network)",
        "menu_4": "Instant Commands",
        "menu_5": "Edit (Transfer Department)",
        "menu_6": "Strategy",
        "menu_7": "Volume Settings",
        "menu_8": "Brightness Settings",
        "menu_9": "Download Settings",
        "menu_10": "Sleep Settings",
        "menu_11": "Device Properties",
        "menu_12": "Edit/Add",
        "menu_13": "Program Manage",
        "menu_14": "Publishing History",
        "menu_15": "Delete (Batch/Single)",
        "menu_16": "Programs Being Published",
        "menu_17": "Grouping",
        "menu_19": "Program List",
        "menu_20": "Content Editing",
        "menu_21": "Program Copy",
        "menu_23": "Program Release",
        "menu_24": "Material Manage",
        "menu_25": "Upload",
        "menu_28": "Quick Release",
        "menu_29": "Template Manage",
        "menu_30": "Public Templates",
        "menu_31": "Use Now",
        "menu_32": "My Templates",
        "menu_33": "Publish to Public Templates",
        "menu_35": "Sharing Records",
        "menu_36": "Check Manage",
        "menu_37": "Program Audit",
        "menu_38": "Audit (Approve/Reject)",
        "menu_39": "Material Audit",
        "menu_41": "Audit History (Operator)",
        "menu_42": "Audit History (Auditor)",
        "menu_43": "View Approval Quantity",
        "menu_44": "Organization Manage",
        "menu_45": "Log Management",
        "menu_46": "Playback Logs",
        "menu_47": "Publishing Logs",
        "menu_48": "Error Logs",
        "menu_49": "Operation Logs",
        "menu_50": "File Logs",
        "menu_51": "Login Logs",
        "menu_52": "Content Approval",
        "menu_53": "Storage Space",
        "menu_54": "Organizational Structure",
        "menu_55": "Role Permissions",
        "menu_56": "Authorization",
        "menu_57": "View (Authorization Permissions)",
        "menu_58": "Organization Members",
        "menu_60": "Reset Subordinate User Passwords",
        "menu_61": "Asset Management",
        "menu_62": "My Balance",
        "menu_63": "View (Fund Details)",
        "menu_64": "My Data Usage",
        "menu_65": "View (Data Usage Details)",
        "menu_66": "Purchase Data Usage",
        "menu_67": "My Capacity",
        "menu_68": "My Devices",
        "menu_69": "Order Details",
        "menu_70": "View (Recharge)",
        "menu_71": "View (Purchased Templates)",
        "menu_72": "View (Purchased Data Usage)",
        "menu_73": "Other Permissions",
        "menu_74": "View (Material and Program Statistics)",
        "menu_75": "View (Assets)",
        "menu_76": "View (Cloud Data Usage/Statistics)",
        "menu_77": "View (Device Online Statistics)"
    },
    login: {
        terminalServiceSystem: 'Terminal Service System',
        accountLogin: 'Account',
        register: 'Register',
        accountLoginTip: 'Login with existing account',
        scanQRCode: 'Please scan QR code',
        readAndAgree: 'I have read and agree',
        readAndAgreeLink: 'User Service Agreement',
        readAndAgreeAgreement: 'Please read and agree to the User Service Agreement',
        forgetpassword: 'Forget Password?',
        resetpassword: 'Reset Password',
        phoneEmptyTip: 'Please enter phone number',
        nextStep: 'Next Step',
        title: 'Welcome',
        submit: 'Login',
        userName: 'Account',
        password: 'Password',
        userNameEmptyTip: 'Please enter account',
        passwordEmptyTip: 'Please enter password',
        passwordFormatTip: 'Please enter the correct password format',
        passwordIsOk: 'Please confirm password',
        passwordSign: 'Please enter password',
        codeTip: "Please enter code",
        phone: 'Phone cannot be empty',
        code: 'Verification code cannot be empty',
        nickname: 'Company name cannot be empty',
        pass: 'Password cannot be empty',
        pwdMessage: "The password length should be between 8 and 20 characters. It cannot contain spaces and must include at least 3 of the following: uppercase and lowercase letters, numbers, and special characters.",
        pwdMessage01: "Please enter an eight-digit password consisting of letters and numbers.",
        pwdMessage02: "Password length: 8 to 20 characters",
        pwdMessage03: "The password cannot contain spaces.",
        pwdMessage04: "The password must include at least one of the following: capital letters, lowercase letters, numbers, or symbols.",
        newpassempty: 'New password cannot be empty',
        newpass: 'The two passwords are inconsistent',
        getcode: 'Get code',
        format: 'Incorrect phone number format',
        chongfa: 's again',
        isSend: 'send',
        noregister: 'No account? Register now',
        Mobile: 'Mobile',
        verificationcode: 'Verification code',
        petname: 'Nickname',
        Quickregistration: 'Quick registration',
        xiugaimima: 'Change password',
        jiumima: 'Old password',
        xinmima: 'New password',
        zaicishuruxinmima: 'Enter the new password again',
        xiugaichenggong: 'Modified successfully',
        xiugaishoujihao: 'Change mobile number',
        dengluzhanghao: 'Login account',
        gongsiid: 'Company ID',
        yonghunicheng: 'User nickname',
        chuangjianshijian: 'Creation time',
        gongsimingcheng: 'Company name',
        denglumima: 'Login password',
        jianyi: 'It is recommended to use a combination of letters and numbers',
        shezhimima: 'Set password',
        shezhishoujihao: 'Modify/set mobile number',
        yibangding: 'Bound',
        weibangding: 'Unbound',
        zhanghuanquan: 'Account security',
        yonghuxinxi: 'User information',
        zhuceSucMsg: 'Congratulations! registered successfully!',
        verificationcodeSucMsg: "Verification code sent successfully!",
        requiredIsEmpty: "The required field cannot be left blank!",
        emailObj: {
            title: 'Email',
            tit: 'Email Login',
            tip: 'Please enter your email address.',
            formatTip: 'Please enter the correct email format.',
        },
        phoneObj: {
            title: 'Mobile',
            tit: 'Mobile Login',
            tip: 'Please enter your mobile phone number.',
            formatTip: 'Please enter the correct mobile phone number format.',
        },
        emailOrPhoneObj: {
            title: 'Email Or Mobile',
            tit: 'Email or Mobile login',
            tip: 'Please enter your email address or mobile phone number.',
            formatTip: 'Please enter a correct email or mobile phone number format.',
        },
        wechatObj: {
            title: 'WeChat',
            tit: 'Log in via WeChat',
        },
        googleObj: {
            title: 'Google',
            tit: 'Google login',
        },
        confirm: 'Confirm',
        confirmSubmit: 'Confirm submission',
        cancel: 'Cancel',
        close: 'Close',
        bindSucMsg: "Binding successful",
        toContinueBindAccount: 'Continue to complete the third-party account binding',
        bindTip01: 'No account? Register one',
        bindTip02: 'Already have an account',
        bindTip03: 'The current third-party account is not bound to the platform account. Please bind an existing account or register and bind a new account, and then you can quickly log in next time.',
        bindTip04: 'Bind existing account',
        bindTip05: 'Register and bind new account',
        bindTip06: 'You have authorized through third-party platforms, complete the following login information to complete binding:',
        bindSubmit: 'Submit for binding',
        enterAccountTip: 'Please enter account name',
        RegisterAndBind: 'Register and bind account',
        loginErr: 'Account Or Password is error',
        "usercenter": "User Center",
        "pleaseInputName": "Please enter name",
        "operationSuccess": "Operation successful!",
        "edit": "Edit",
        "xiugai": "Modify",
        "userData": "Personal Profile",
        "changePassword": "Change Password",
        "account": "Account",
        "userName01": "Username",
        "phoneNumber": "Phone Number",
        "role": "Role",
        "createTime": "Creation Time",
        "genghuang": "Replace",
        "bangding": "Bind",
        "unbind": "Unbind",
        "plesaseSelectBindingType": "Please select binding type",
        "pleaseConfirmCont": "Please confirm that I have read this content",
        "confirmReadCont": "I have read this content",
        "frequentTip": "Too many operations, please try again later!",
        "zhuxiaoBtn": "Cancel Account",
        "zhuxiaoTitle": "Account Cancellation",
        "querenZhuxiao": "Confirm Cancellation",
        "jiXu": "Continue",
        "sendCodeBtn": "Send Verification Code",
        "passwordIsNotOldPassword": "The confirmed password is different from the new password",
        "passwordIsOldPassword": "The new password is the same as the original password",
        "passFormatError": "Please enter the correct password format",
        "oldPassWord": "Original Password",
        "newPassWord": "New Password",
        "inputPlaceholder": "Please enter",
        "confirmPassword": "Confirm Password",
        "zhuxiaoTip": `
            1. Account cancellation is an irreversible operation. Once the account is cancelled, you will no longer be able to log in or use this account or any third-party account registered and logged in through this account. Please back up all relevant account information and data yourself.
            2. Before registering this account, you must confirm that all assets have been cleared and there are no disputes. Once this account is cancelled, it shall be deemed that you have waived ownership of all assets and rights and interests in this account, and they cannot be recovered or retrieved.
            3. If the number of cancelled accounts registered with the same phone number reaches 3 in total, the phone number will not be allowed to register a new account again, nor can it be bound to any other accounts.
        `

    },
    home: {
        title: 'Home',
        quickOperation: 'Quick operation',
        addDevice: 'Add device',
        publishProgram: 'Publish program',
        publishMaterial: 'Publish material',
        makeProgram: 'Make program',
        uploadMaterial: 'Upload material',
        todayData: 'Today data (updated hourly)',
        playNumChart: 'Play count statistics',
        deviceOnlineStatus: 'Device online status',
        onLineDevice: 'Online devices',
        unLineDevice: 'Offline devices',
        programPlayTime: 'Program play time statistics',
        downloadSoft: 'Software download',
        adminApp: 'Mobile client',
        playerApp: 'Player terminal',
        downloadAdminApp: 'Click to download client',
        downloadPlayerApp: 'Click to download player',
        aboutUs: 'About us',
        userManual: 'User manual',
        message: 'Leave a message',
    },
    device: {
        inputPlaceholder: 'Please enter ',
        selectPlaceholder: 'Please select ',
        osTypeStr: 'Terminal system',
        onLineStatus: 'Online status',
        dpi: 'Resolution',
        companyDeptIdName: 'Department',
        deviceGroupIdName: 'Group',
        editOrMove: 'Edit/Move',
        loanOriginationFee: 'Loan origination fee',
        strategyInfoLook: 'Strategy info view',
        programLook: 'Program view',
        addEquipments: 'Add devices',
        luminanceSet: 'Brightness control',
        terminal: 'Terminal settings',
        transferCompany: 'Transfer department',
        releasedProgram: 'Publish program',
        screenshot: 'Screenshot',
        changeGroup: 'Change group',
        defaultGroup: 'Default group',
        operation: 'Operation',
        edit: 'Edit',
        saveEdit: 'Save edit',
        add: 'Add',
        save: 'Save',
        setting: 'Setting',
        program: 'Program',
        unbind: 'Unbind',
        sleep: 'Sleep',
        wakeup: 'Wake up',
        restart: 'Restart',
        shutdown: 'Shutdown',
        reportLog: 'Report log',
        clearPlayData: 'Clear player data',
        offlineWarn: 'Device is offline, please retry when online!',
        confirmUnbind: 'Confirm unbind',
        confirmReset: 'Confirm clear',
        confirmDelete: 'Confirm delete',
        delete: 'Delete',
        cancelDelete: 'Cancel delete',
        confirmResetSuccess: 'Clear success',
        confirm: 'Confirm',
        cancel: 'Cancel',
        operationSuccess: 'Operation success',
        unbindSuccess: 'Unbind success',
        pleaseSelectDevice: 'Please select device',
        pleaseSelectOnlineDevice: 'Please select online device',
        confirmMixOperation: 'Selected contains offline devices; settings won’t apply to them. Continue?',
        pleaseSelectDate: 'Please select date',
        reportSuccess: 'Report success',
        deviceSetting: 'Device settings',
        default: 'Default',
        all: 'All',
        deviceList: 'Device list',
        addDevice: 'Add device',
        department: 'Department',
        deviceType: 'Resolution',
        osType: 'OS type',
        onlineState: 'Online status',
        online: 'Online',
        offline: 'Offline',
        notActive: 'Not activated',
        search: 'Please enter keyword',
        batchOperation: 'Batch operation',
        allDevices: 'All devices',
        deviceAttribute: 'Device attributes',
        selectReportDate: 'Select report date',
        inputName: 'Please enter name',
        inputWidth: 'Please enter width',
        inputHeight: 'Please enter height',
        inputResolutionRatio: 'Please enter an integer greater than 0!',
        inputSort: 'Please enter sort',
        serialNum: 'No.',
        name: 'Name',
        width: 'Width',
        height: 'Height',
        resolutionRatio: 'Resolution',
        inputResolutionRatioName: 'Please enter resolution name',
        sort: 'Sort',
        personal: 'Personal',
        system: 'System',
        type: 'Type',
        systemDefaultSettingUneditable: 'System default cannot be edited!',
        systemDefaultSettingUnDeletable: 'System default cannot be deleted!',
        newz: 'New',
        total: 'Total',
        totalNum: 'items',
        strategyName: 'Strategy name',
        associatedTerminalNum: 'Associated terminal count',
        createTime: 'Create time',
        pleaseSelectStrategy: 'Please select strategy!',
        onlySelectOneData: 'Only one item can be selected!',
        downloadStrategy: 'Download strategy',
        inputStrategyName: 'Please enter strategy name',
        luminanceControl: 'Brightness control',
        volumeStrategy: 'Volume strategy',
        saveSuccess: 'Save success',
        screenAngle: 'Screen rotation(°)',
        startTime: 'Start time',
        endTime: 'End time',
        repeat: 'Repeat',
        monday: 'Mon',
        tuesday: 'Tue',
        wednesday: 'Wed',
        thursday: 'Thu',
        friday: 'Fri',
        saturday: 'Sat',
        sunday: 'Sun',
        everyday: 'Everyday',
        downloadSpeed: 'Download speed',
        inputDownloadSpeed: 'Please enter download speed',
        operator: 'Operator',
        pleaseSelectDeleteData: 'Please select data to delete!',
        confirmBatchDelete: 'Confirm batch delete?',
        pleaseInputName: 'Please enter name',
        detailSetting: 'Detail settings',
        weekPlan: 'Weekly plan',
        specialDateSetting: 'Special date settings',
        weekdayInfo: 'Weekday is required!',
        volumeInfo: 'Volume is required!',
        timeError: 'Time selection error!',
        editSuccess: 'Edit success!',
        addSuccess: 'Add success!',
        addSpecialPlan: 'Add special strategy plan',
        downloadSpeedInfo: 'Download speed: (0 means forbidden)',
        pleaseSelectStartTime: 'Please select start time',
        pleaseSelectEndTime: 'Please select end time',
        luminanceError: 'Please enter correct brightness!',
        defaultLuminance: 'Default brightness',
        luminance: 'Brightness',
        defaultLuminanceInfo: 'Default brightness (100 brightest, 0 darkest)',
        volume: 'Volume',
        saveLuminance: 'Save brightness',
        changeSuccess: 'Change success!',
        changeNetwork: 'Change network',
        netName: 'Network name',
        nameempty: 'Network name cannot be empty',
        currentNetwork: 'Current network',
        ipAddress: 'IP address',
        dailyMode: 'Daily mode',
        weeklyMode: 'Weekly mode',
        turnOnTime: 'Power on time',
        turnOffTime: 'Power off time',
        startSleep: 'Start sleep',
        endSleep: 'End sleep',
        batchDelInfo: 'Confirm delete selected items?',
        timeCannotBeEmpty: 'Time cannot be empty!',
        startUp: 'Power on',
        shutDown: 'Power off',
        volumeSize: 'Volume size',
        defaultVolume: 'Default volume (100 max, 0 mute)',
        chooseStartTime: 'Please select start time',
        chooseEndTime: 'Please select end time',
        saveVolume: 'Save volume',
        screenRotationUnSaved: 'Screen rotation not saved',
        volumeSettingUnSaved: 'Volume setting not saved',
        luminanceSettingUnSaved: 'Brightness setting not saved',
        confirmClosePopup: 'Confirm close this popup?',
        volumeSettingSuccess: 'Volume modified successfully',
        luminanceSettingSuccess: 'Brightness modified successfully',
        advancedSettingUnSaved: 'Advanced settings not saved',
        settingTitle: 'Terminal settings',
        volumeSetting: 'Volume settings',
        luminanceSetting: 'Brightness settings',
        downloadSetting: 'Download settings',
        sleepSetting: 'Sleep settings',
        onOffSetting: 'Scheduled power',
        screenRotation: 'Screen rotation',
        namingError: 'Naming error, spaces not allowed!',
        deleteSuccess: 'Delete success',
        deleteFolder: 'Delete folder',
        pleaseInputDeviceName: 'Please enter device name',
        pleaseInputDeviceId: 'Please enter device id',
        discoverDevice: 'Discover device',
        deviceId: 'Device ID',
        bound: 'Bound',
        bind: 'Bind',
        noDevice: 'No device',
        refresh: 'Refresh',
        manualAdd: 'Manual add',
        deviceGroup: 'Device group',
        pleaseSelectGroup: 'Please select group!',
        deviceName: 'Device name',
        goAdd: 'Go add',
        close: 'Close',
        bindCountInsufficient: 'Binding quota insufficient, upgrade and add!',
        displayNumber: 'Display number',
        groupName: 'Group name',
        pleaseSelectGroupName: 'Please fill group name!',
        moveGroup: 'Move group',
        longitude: 'Longitude',
        latitude: 'Latitude',
        nationality: 'Nationality',
        province: 'Province',
        city: 'City',
        county: 'County',
        outNetIp: 'Public IP',
        inNetIp: 'Private IP',
        companyName: 'Company name',
        Info: 'Detail',
        android: 'Android',
        win: 'Windows',
        osVersion: 'OS version',
        softwareVersion: 'Software version',
        diskSize: 'Disk size',
        useSize: 'Used size',
        macAddr: 'MAC address',
        longitudeLatitudeInfo: 'Longitude and latitude must be both empty or both filled!',
        terminalName: 'terminal name',
        terminalGroup: 'terminal group',
        reportJournal: 'Report',
        systemVersion: 'System version',
        storageSpace: 'Storage space',
        resolution: 'Resolution',
        runningMemory: 'RAM',
        model: 'Model',
        registerStatus: 'Register status',
        password: 'Password',
        passwordInfo: 'Please enter 6-18 letters or numbers!',
        group: 'Group',
        address: 'Address',
        remark: 'Remark',
        renewalPeriod: 'Renewal period',
        money: 'Fee',
        latitudeInfo: 'Please enter correct latitude!',
        totalPayment: 'Total amount',
        longitudeInfo: 'Please enter correct longitude!',
        setMeal: 'Plan',
        number: 'Number',
        programName: 'Program name',
        playStatus: 'Play status',
        playType: 'Play type',
        play: 'Play',
        pause: 'Pause',
        playTime: 'Play time',
        programDeleted: 'Program deleted',
        playSuccess: 'Program scheduled',
        pauseSuccess: 'Pause success',
        playCycle: 'Loop Playback',
        playInsert: 'Play insert',
        withdrawSuccess: 'Withdraw success',
        withdrawInfo: 'Please select program to withdraw!',
        programBelong: 'Belong program',
        checkAll: 'Select all',
        batchDel: 'Batch delete',
        delConfirm: 'Confirm delete selected?',
        check: 'Checked',
        noProgram: 'No program',
        details: 'Details',
        screenshotFail: 'Screenshot failed',
        policyName: 'Policy name',
        terminalNum: 'Associated terminal count',
        powerStrategy: 'Power strategy',
        pleaseSelectDepartment: 'Please select department!',
        screenshotControl: 'Screenshot control',
        未激活: 'Not activated',
        已激活: 'Activated',
        未绑定: 'Unbound',
        已绑定: 'Bound',
    },
    programManage: {
        programList: 'Program list',
        publishProgram: 'Program publish trace',
        week1: 'Mon',
        week2: 'Tue',
        week3: 'Wed',
        week4: 'Thu',
        week5: 'Fri',
        week6: 'Sat',
        week7: 'Sun',
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
        saturday: 'Saturday',
        sunday: 'Sunday',
        name: 'Name',
        preview: 'Preview',
        playDeviceNum: 'Play device count',
        copyDeviceCode: 'Click to copy',
        osType: 'System type',
        playDate: 'Play date',
        playWeek: 'Play week',
        everyday: 'Everyday',
        start: 'Start',
        end: 'End',
        playOperateStatusStr: 'Publish status',
        playDevice: 'Play device',
        downloadView: 'Download view',
        publisher: 'Publisher',
        publishTime: 'Publish time',
        operation: 'Operation',
        add: 'Add',
        groupName: 'Group name',
        selectDevice: 'Select terminal',
        searchDevice: 'Search terminal',
        pleaseFillGroupName: 'Please fill group name!',
        remarkInfo: 'Remark',
        compile: 'Edit',
        withdrawConfirm: 'Confirm withdraw this program?',
        confirm: 'Confirm',
        cancel: 'Cancel',
        withdraw: 'Withdraw',
        batchWithdraw: 'Batch withdraw',
        batchPublish: 'Batch publish',
        batchDelete: 'Batch delete',
        batchOperation: 'Batch operation',
        notUse: 'Not used',
        notChecked: 'Not reviewed',
        notPass: 'Not approved',
        delete: 'Delete',
        publishTextLeft: 'Published',
        offTextLeft: 'Paused',
        pleaseSelectProgramToMove: 'Please select program to move!',
        pause: 'Pause',
        pauseConfirm: 'Confirm pause?',
        play: 'Play',
        downloadUdisk: 'Download to USB',
        deviceList: 'Device list',
        groupSelection: 'Group selection',
        operationSuccess: 'Operation success',
        deleteSuccess: 'Delete success',
        selectDate: 'Select date',
        publishStatus: 'Publish status',
        checkStatus: 'Review status',
        waitAuditing: 'Pending review',
        auditPass: 'Approved',
        auditRefuse: 'Rejected',
        all: 'All',
        playStatus: 'Playing',
        playStatust: 'Play status',
        pauseStatus: 'Paused',
        notStartStatus: 'Not started',
        resolutionratio: 'Resolution',
        totalNum: 'items',
        programName: 'Program name',
        playStartTime: 'Play start time',
        playEndTime: 'Play end time',
        createTime: 'Create time',
        nationality: 'Nationality',
        province: 'Province',
        city: 'City',
        county: 'County',
        address: 'Address',
        ip: 'IP address',
        location: 'Location',
        log: 'Log',
        pleaseFillProgramName: 'Please fill program name!',
        selectGroup: 'Select group',
        startTime: 'Start time',
        endTime: 'End time',
        publishCycle: 'Publish cycle',
        publishDeviceNum: 'Publish device count',
        pleaseSelectRecord: 'Please select record',
        deviceName: 'Terminal name',
        deviceId: 'Terminal device ID',
        deviceGroupIdName: 'Group',
        notClassified: 'Unclassified',
        osTypeStr: 'Terminal OS',
        storageSpace: 'Storage space',
        onLineStatus: 'Online status',
        onLine: 'Online',
        offLine: 'Offline',
        sleep: 'Sleep',
        unknown: 'Unknown',
        registerStatus: 'Register status',
        trialPeriod: 'Trial period',
        notActive: 'Not active',
        active: 'Active',
        parameterError: 'Parameter error!',
        pleaseSelectProgram: 'Please select program!',
        pleaseSelectProgramEdit: 'Please select program to edit!',
        confirmWithdrawSelectedProgram: 'Confirm withdraw selected program?',
        withdrawSuccess: 'Withdraw success',
        allPrograms: 'All programs',
        defaultGroup: 'Default group',
        cannotShareEmptyProgram: 'Cannot share empty program!',
        onlyShareYourProgram: 'Only share your program!',
        pleaseSelectProgramEditPublishTime: 'Please select program edited with publish time!',
        pleaseSelectDevice: 'Please select device!',
        programDetail: 'Program detail',
        errorReason: 'Error reason',
        availableStorageSpaceInsufficient: 'Insufficient storage space',
        partialDeviceReleaseFailure: 'Partial device publish failed',
        allDeviceReleaseSuccess: 'All devices publish success',
        partialDeviceReleaseSuccess: 'Partial devices publish success',
        allGroup: 'All groups',
        allProgram: 'All programs',
        unGrouped: 'Ungrouped',
        replaceProgram: 'Replace program',
        replaceProgramTip: 'New publish will replace player’s existing program data!',
        screen: 'Single/Double screen',
        singleScreen: 'Single',
        doubleScreen: 'Double',
        playSetting: 'Play settings',
        batchPlaySetting: 'Batch set play time',
        individualPlaySetting: 'Set play time individually',
        playTime: 'Play time',
        daily: 'Daily',
        weekdays: 'Mon-Fri',
        monthly: 'This month',
        advancedSetting: 'Advanced settings',
        playProgram: 'Play program',
        searchProgram: 'Please enter keyword',
        shareAddressNotExist: 'Link does not exist, please retry',
        copySuccess: 'Copy success',
        shareLink: 'Share link',
        publish: 'Publish',
        noResource: 'No resource',
        single: 'Single',
        double: 'Double',
        time: 'Time',
        associatedTerminalNum: 'Associated terminal count',
        default: 'Default',
        moveGroup: 'Move group',
        pleaseSelectGroup: 'Please fill group name!',
        copy: 'Copy',
        FUBEN: 'Copy',
        nameempty: 'Name cannot be empty',
        whitespace: 'Naming error, spaces not allowed!',
        programWhitespace: 'Naming error, program name cannot contain spaces!',
        pleaseSelectResolution: 'Please select resolution!',
        dataError: 'Data error!',
        createProgram: 'Create program',
        directCreate: 'Create directly',
        myTemplate: 'My templates',
        use: 'Use',
        free: 'Free',
        loadMore: 'Load more',
        confirmDelete: 'Confirm delete',
        deleteGroup: "Delete group",
        notPublished: "Not published",
        notPassed: "Not passed",
        notUsed: "Not used",
        confirmDeleteSelectedProgram: "confirm delete selected program",
        companyName: "company name",
        programCannotDownload: "This program cannot be downloaded!",
        publishMaterial: "publish Materials",
        playMaterial: "Play Materials",
        pleaseInputMaterialName: "Please enter the name of the material.",
        size: "size",
        pleaseInputDeviceName: "Please enter the device name.",
        total: 'Total',
        allMaterial: "All Material",
        allDevices: 'All devices',
        "saveSuccess": "Saved successfully",
        "savefaill": "Save failed",
        "playMode": "Play mode",
        "cyclePlay": "Cycle play",
        "insertPlay": "Insert play",
        "noData": "No data",
        "Add": "Add",
        "replace": "Replace",
        "repeat": "Repeat",
        "start01": "Start",
        "end01": "End",
        "startDate": "Start date",
        "endDate": "End date",
        "useNow": "Use immediately",
        "fillStartEndTimeFirst": "Please fill in the start and end time before adding",
        "fillFullPlayTime": "Please fill in the complete play time",
        "fillCorrectPlayTime": "Please fill in the correct play time period",
        "sDateAndEDateBothEmptyOrFilled": "Start date and end date must be both empty or both filled"
    },
    source: {
        addResource: "Add Resource",
        width: "Width",
        height: "Height",
        size: "Size(KB)",
        name: "Name",
        pleaseInputResourceName: "Please enter the resource name!",
        addToGroup: "Add to Group",
        remark: "Remarks",
        promptFgIllustrate: "Illustration",
        promptFgRealisticPhoto: "Realistic Photo",
        promptFgSimplisticDrawing: "Stick Figure",
        promptFgChineseStyle: "Chinese Style",
        promptFgPixelArt: "Pixel Art",
        noModel: "No model available, please contact the administrator!",
        getModelFailed: "Failed to get the model, please try again later! Or contact the administrator!",
        createImagePrompt: "Generating image, please keep this page open!",
        promptEmpty: "Please enter the prompt word",
        dpiEmpty: "Please select the image ratio!",
        fgEmpty: "Please select a style!",
        style: "Style",
        idEmpty: "Image ID cannot be empty",
        exist: "This image already exists in the material library",
        addSuccess: "Material added successfully",
        saveError: "Failed to save the image, please try again later!",
        delSuccess: "Deleted successfully",
        generateImage: "Text to Image",
        generateImagePlaceholder: 'Please enter what you want to generate, e.g. A butterfly dancing gracefully in a sea of flowers',
        aiExpand: "AI Expand",
        negativePrompt: "Negative Prompt",
        negativePromptTooltip: "Used to explicitly exclude content or features that the user does not want to appear in the output",
        imageRatio: "Image Ratio",
        generateImageBtn: "Generate Now",
        shengchengjieguo: "Generation Result",
        generateImageLoadingTip: "Generating, do not click repeatedly or close the page...",
        Tooltip: "Come and AI your creativity",
        saveToMaterial: "Save to Material Library",
        publish: "Publish Now",
        download: "Download",
        generateHistory: "Generation History",
        hide: "Collapse",
        cancel: "Cancel",
        useExpand: "Use Expansion",
        all: "All",
        delete: "Delete",
        loadMore: "Load More",
        aiTip: "Content is generated by artificial intelligence models and does not represent the platform's views, positions or attitudes. Please use AI content in a reasonable and compliant manner.",
        operationSuccess: "Operation Successful",
        moveGroup: "Move to Group",
        groupName: "Group Name",
        pleaseSelectGroup: "Please select a group name!",
        shenhe: "Review",
        shenheStatus: "Review Status",
        shenheSuccess: "Review Approved",
        shenheRefuse: "Review Rejected",
        pleaseSelectShenheStatus: "Please select the review status!",
        shenheRemark: "Review Remarks",
        pleaseInputShenheRemark: "Please enter the review remarks!",
        pleaseInputFileName: "Please enter the file name!",
        whitespace: "Naming error, no spaces allowed in the file name!",
        dataError: "Data error!",
        confirmDelete: "Confirm Deletion",
        confirm: "Confirm",
        deleteFolder: "Delete Folder",
        add: "Add",
        edit: "Edit",
        fileName: "File Name",
        group: "Group",
        resolution: "Resolution",
        type: "Type",
        image: "Image",
        music: "Music",
        video: "Video",
        uploadTime: "Upload Time",
        uploadUser: "Uploader",
        checkTime: "Review Time",
        checkUser: "Reviewer"
    },
    setting: {
        nameempty: "Name cannot be empty",
        heightempty: "Height cannot be empty",
        widthempty: "Width cannot be empty",
        resolutionratio: "Resolution",
        name: "Name",
        opteration: "Operation",
        compile: "Edit",
        delete: "Delete",
        newz: "Add New",
        compileratio: "Edit Resolution",
        sheizhifenbianlvmingcheng: "Set Resolution Name",
        shezhigaodu: "Set Height",
        shezhikuandu: "Set Width",
        xinzengfenbianlv: "Add New Resolution",
        bianma: "Code",
        bianjizhongduanmingcheng: "Edit Terminal Name",
        xinzengzhongduan: "Add New Terminal",
        selectPrimaryColor: 'Select Theme Color',
        fullScreen: 'Full Screen',
        exitFullScreen: 'Exit Full Screen'
    },
    tabs: {
        refresh: 'Refresh',
        refreshAll: 'Refresh All',
        close: 'Close',
        closeOthers: 'Close Others',
        closeAll: 'Close All',
        closeLeft: 'Close All to the Left',
        closeRight: 'Close All to the Right',
    },
    errorPage: {
        needLogin: 'Need to Log In!',
        pageNotFound: 'Page Not Found!',
        redirectTo: 'You can redirect to',
        orReturn: 'or return',
        previousStep: 'Previous Step',
    },
    headerUs: {
        systemNotice: "System Notice",
        allNotices: "All Notices",
        viewAllMessages: "View All Messages",
        contactUs: "Contact Us",
        operationSuccess: "Operation Successful!",
        leaveMessage: "Leave a Message",
        messageTitle: "Title",
        messageTitleTip: "Please enter the title!",
        messageContentTip: "Within 150 words",
        submit: "Submit",
        markAsRead: "Marked as read",
        success: "Successful！"
    },
    material: {
        allMaterial: "All Materials",
        defaultGroup: "Default Group",
        auditStatus: "Audit Status",
        auditPassed: "Audit Passed",
        auditRejected: "Audit Rejected",
        pendingAudit: "Pending Audit",
        all: "All",
        operateSuccess: "Operation successful!",
        pleaseSelectMaterial: "Please select material!",
        moveGroup: "Move Group",
        pleaseSelectGroup: "Please select group!",
        batchPublish: "Batch Publish",
        batchRecall: "Batch Recall",
        batchDelete: "Batch Delete",
        materialList: "Material List",
        uploadMaterial: "Upload Material",
        materialType: "Material Type",
        pleaseInputMaterialName: "Please enter material name",
        selectAll: "Select All",
        confirmDeleteSelectedMaterial: "Are you sure to delete the selected materials?",
        deleteSuccess: "Delete successful",
        delete: "Delete",
        publish: "Publish",
        recall: "Recall",
        confirmRecallSelectedMaterial: "Are you sure to recall the selected materials?",
        pleaseSelectMaterialGroup: "Please select material group!",
        recallSuccess: "Recall successful",
        publishSuccess: "Publish successful",
        batchOperate: "Batch Operation",
        item: "item",
        confirmDelete: "Are you sure to delete?",
        edit: "Edit",
        confirmRecall: "Are you sure to recall?",
        unaudited: "Unaudited",
        notPassed: "Not Passed",
        operate: "Operation",
        resolution: "Resolution",
        none: "None",
        confirm: 'Confirm',
        cancel: 'Cancel',
        AICreation: 'AI Creation',
    },
    uploadFile: {
        "operationSuccess": "Operation Successful",
        "uploadFile": "Upload Management",
        "uploadSuccess": "Upload Successful",
        "uploadCompleted": "Upload Completed",
        "uploadFail": "Upload Failed",
        "ConversionFailed": "Conversion Failed!",
        "loading": "Loading...",
        "beQueuing": "Queuing...",
        "Uploading": "Conversion in progress...",
        "ConversionIng": "ConversionIng...",
        "ConventionalResources": "Regular Resources",
        "DocumentResources": "Document Resources",
        "complete": "Complete",
        "upload": "Upload",
        "fileSizeWraning01": "File size exceeds ",
        "fileSizeWraning02": "Please modify and re-upload!",
        "fileIsEmpty": "File is empty",
        "uploadFileTip": "Unsupported file format",
        "unablePreview": "Failed to add to asset library, preview unavailable",
        "confirmDelete": "Are you sure you want to delete?",
        "deleteSuccess": "Deletion Successful",
        "delete": "Delete",
        "confirm": "Confirm",
        "preview": "Preview",
        "close": "Close",
        "cancel": "Cancel",
        "fileType": "File Type",
        "fileSize": "File Size",
        "conversionProgress": "Conversion Progress",
        "progress": "Progress",
        image: "Image",
        video: "Video",
        audio: "Audio",
        limitTip01: "Upload up to ",
        limitTip02: " files at a time",
        okTip: "Uploading assets, please do not close this window!",
        usableSize: "Available Storage",
        sizeUnableTip: "Insufficient available storage space. Please clean up unused assets to free up space or contact your dealer to expand capacity.",
        view: "View Details",
        fileName: "File Name",
    },
    template: {
        "inputPlaceholder": "Please input",
        "selectPlaceholder": "Please select",
        "noAuths": "No permission, please contact the administrator",
        "operationSuccess": "Operation successful",
        "total": "Total",
        "totalNum": "items",
        "dan": "Single",
        "shaung": "Double",
        "pleaseSelectGroup": "Please select a group",
        "preview": "Preview",
        "free": "Free",
        "use": "Use",
        "dpi": "Resolution",
        "delete": "Delete",
        "confirmDelete": "Confirm deletion",
        "confirmDeleteSelectedTemplate": "Are you sure to delete this template?",
        "push": "Publish",
        "pushConfirm": "Are you sure to publish to public templates?",
        "pushRemovalConfirm": "Are you sure to take it off the shelf from public templates?",
        "templateOrderRecord": "Template Order Record",
        "unpublished": "Unpublished",
        "auditing": "Under Review",
        "publishRejected": "Publish Rejected",
        "publishSuccess": "Publish Successful",
        "offShelf": "Off Shelf",
        "公共模版": "Public Templates",
        "我的模板": "My Templates",
        "共享记录": "Sharing Records",
        "name": "Name",
        "pubdate": "Publish Time",
        "keySeachTip": "Please enter keywords",
        "allGroup": "All Groups",
        "add": "Add",
        "edit": "Edit",
        "programName": "Program Name",
        "selectGroup": "Select Group"
    },
    checkManage: {
        total: "Total",
        totalNum: "entries",
        operationSuccess: "Operation Successful!",
        checkUserLogs: "Audit Record (operator)",
        checkLogs: "Audit Record (Auditor)",
        sourceCheck: "Content Audit",
        programCheck: "Program Audit",
        checkAll: 'Select all',
        auditPass: 'Approved',
        auditRefuse: 'Rejected',
        auditPass01: "Approved",
        auditRefuse01: "Rejected",
        auditRefuse02: "Refusal of review",
        auditor: "Auditor",
        agentUserName: "Assigner",
        interrogationTime: "Interrogation Time",
        checkTime: "Audit Time",
        checkName: "Audit Name",
        checkType: "Audit Type",
        checkIp: "Audit IP Address",
        checkReason: "Reason",
        checkStatus: "operation content",
        rangePicker: "Audit Date",
        keyWord: "Key Word",
        all: "all",
        program: 'program',
        material: 'material',
        dan: "Single",
        shaung: "Double",
        pleaseSelectProgram: 'Please select program!',
        pleaseSelectMaterial: "Please select material!",
        preview: "preview",
        dpi: 'Resolution',
        auditRefuseTip: "Please enter the reason for refusal.",
        unreviewed: "Unreviewed",
        notPassed: "Not passed",
        notUsed: "Not used",
        edit: "edit",
        none: "none",
        name: "name",
        size: "size",
        type: "type",
        uploadTime: "upload Time",
        uploadUser: "upload User",
        checkUser: "check User",
        image: "image",
        music: "music",
        video: "video",
    },
    systemSet: {
        "total": "Total",
        "totalNum": "items",
        "inputPlaceholder": "Please input",
        "selectPlaceholder": "Please select",
        "userList": "Organization Members",
        "roleList": "Role & Permissions",
        "department": "Organization Structure",
        "diskInfo": "Storage Space",
        "approveSet": "Content Approval",
        "logList": "Log Management",
        "name": "name",
        "account": "Account",
        "userName": "User Name",
        "phoneNumber": "Phone Number",
        "role": "Role",
        "createTime": "Creation Time",
        "operation": "Operation",
        "edit": "Edit",
        "delete": "Delete",
        "addNew": "Add New",
        "add": "Add",
        "resetPassword": "Reset Password",
        "confirmDelete": "Confirm Delete",
        "departmentOrganization": "Department & Organization",
        "addNewUser": "Add New User",
        "pleaseEnterUserName": "Please enter user name",
        "confirmPasswordNotMatch": "Confirm password does not match the entered password!",
        "operationSuccess": "Operation successful!",
        "userNickname": "User Nickname",
        "pleaseEnterUserNickname": "Please enter user nickname",
        "userNicknameRequired": "User nickname cannot be empty!",
        "password": "Password",
        "pleaseEnterPassword": "Please enter password",
        "passwordRequired": "Password cannot be empty!",
        "passwordTip": "Your password security is too low (the password must contain any 3 of uppercase and lowercase letters, numbers, and special characters, and the length must be at least 8)",
        "confirmPassword": "Confirm Password",
        "pleaseEnterPhoneNumber": "Please enter phone number",
        "phoneNumberRequired": "Phone number cannot be empty!",
        "phoneNumberFormatError": "Please enter a valid phone number!",
        "roleRequired": "Role cannot be empty!",
        "required": "cannot be empty!",
        "departmentName": "Department",
        "modifyPassword": "Modify Password",
        "newPassword": "New Password",
        "pleaseEnterNewPassword": "Please enter new password",
        "pwdMessage": "The password length should be between 8 and 20 characters. It cannot contain spaces and must include at least 3 of the following: uppercase and lowercase letters, numbers, and special characters.",
        "all": "All",
        "noAuths": "No permissions, please contact the administrator",
        "departmentName01": "Department Name",
        "image": "Image",
        "music": "Music",
        "video": "Video",
        "buySize": "Purchase Quantity",
        "totalMoney": "Payment Amount",
        "buycreateTime": "Purchase Time",
        "endTime": "Expiration Time",
        "buyTypeStr": "Order Type",
        "sourceCheck": "Material Review",
        "programCheck": "Program Review",
        "programName": "Program Name",
        "diskExpansion": "It is recommended to clean up expired/unused materials in a timely manner during use to ensure the available capacity of the system. If you need more space, you can contact your device supplier to obtain capacity expansion services for cloud storage space. This service may incur fees, please refer to the dealer's information for details.",
        "selectPermission": "Please select permissions",
        "checkPermission": "Please check permissions",
        "addRole": "Add Role",
        "enterRoleName": "Please enter the role name",
        "roleName": "Role Name",
        "roleNameRequired": "Role name cannot be empty!",
        "remark": "Remark",
        "enterRemark": "Please enter a remark",
        "permissionSetting": "Permission Settings",
        "deleteSuccess": "Deleted successfully!",
        "confirmToDelete": "Are you sure to delete?",
        "orgName": "Organization Name",
        "orgNameRequired": "Organization name cannot be empty!",
        "orgRemark": "Organization Remark",
        "enterOrgRemark": "Please enter the organization remark",
        "capacityUsage": "Capacity Usage",
        "usedCapacity": "Used Capacity",
        "totalCapacity": "Total Capacity",
        "remainingCapacity": "Remaining Capacity",
        "capacityExpansion": "Capacity Expansion",
        "enable": "Enable",
        "disable": "Disable",
        "userName01": "User Name",
        "loginTime": "Login Time",
        "ipAddress": "IP Address",
        "loginResult": "Login Result",
        "selectDate": "Select Date",
        "enterDate": "Please select a date",
        "selectStartTime": "Please select the start time",
        "selectEndTime": "Please select the end time",
        "enterUserName": "Please enter the user name",
        "userCount": "User Count",
        "roleDesc": "Role Description",
        "roleAuthorization": "Role Authorization",
        "success": "Success",
        "failure": "Failure",
        "time": "Time",
        "operationContent": "Operation Content",
        "playCount": "Play Count",
        "playDuration": "Play Duration",
        "selectDevice": "Select Device",
        "enterProgramName": "Please enter the program name",
        "serialNumber": "Serial Number",
        "publishContentName": "Published Content Name",
        "playMode": "Play Mode",
        "cyclePlay": "Cycle Play",
        "insertPlay": "Insert Play",
        "paddingPlay": "Padding Play",
        "playDeviceId": "Play Device ID",
        "playDeviceName": "Play Device Name",
        "publishTime": "Publish Time",
        "downloadStatus": "Download Status",
        "notDownloaded": "Not Downloaded",
        "downloading": "Downloading",
        "downloadSucceeded": "Download Succeeded",
        "downloadFailed": "Download Failed",
        "enterPublishContentName": "Please enter the published content name",
        "terminalId": "Terminal ID",
        "belongOrg": "Affiliated Organization",
        "reportTime": "Report Time",
        "reportIp": "Report IP",
        "logInfo": "Log Information",
        "details": "Details",
        "confirmDeletion": "Are you sure to delete?",
        "logDetails": "Log Details",
        "download": "Download",
        "deptOrg": "Department Organization",
        "query": "Query",
        "queryByTerminalId": "Query by Terminal ID",
        "batchDeleteLogs": "Batch Delete Logs",
        "customTimeDeleteLogs": "Custom Time Delete Logs",
        "selectTimeRangeFirst": "Please select the time range first",
        "deleteAllDeviceLogsIfEmpty": "If the device ID is not filled in, the logs of all devices will be deleted by default",
        "enterDeviceIdToDeleteLogs": "Please enter the device ID for which logs are to be deleted",
        "confirmDeleteAction": "Confirm Delete",
        "selectDeleteRangeFirst": "Please select the deletion range first",
        "networkConnectionFailed": "Network connection failed",
        playLog: "Play Log",
        publishLog: "Publish Log",
        errorLog: "Error Log",
        operationLog: "Operation Log",
        fileLog: "File Log",
        userOperateLog: "Login log",
    },
    userManual: {
        userManual: "User manual",
        noData: "no Data",
    },
    "systemNotice": {
        "systemNotice": "System Notification",
        "noData": "No Data",
        "total": "Total ",
        "totalNum": " Items",
        "markAllRead": "Mark All As Read",
        "deleteAll": "Delete All",
        "all": "All",
        "unread": "Unread",
        "read": "Read",
        "type": "Type",
        "content": "Content",
        "date": "Date",
        "status": "Status",
        "confirmDelete": "Are you sure you want to delete?",
        "confirm": "Confirm",
        "cancel": "Cancel",
        "delete": "Delete"
    }
};
